module.exports = __webpack_public_path__ + "img/animation1.b358f186.png";